import { DEFAULT_SERVER_URL } from '../../../react/features/base/settings/constants';
import Settings from '../../settings/Settings';

export function getFileRecordingMetadata(state) {
    const obj = { localDate: Settings.getLocalDate() };

    if (navigator.product === 'ReactNative') {
        const { room, pbxSerial, xmppLogin = '', xBeesUserId = '', serverURL } = state['features/base/settings'];
        const { subject } = state['features/base/conference'];
        const [ userId ] = xmppLogin.split('@');

        obj.room = room;
        obj.roomSubject = subject;
        obj.username = userId;
        obj.xBeesUserId = xBeesUserId;
        obj.pbxSerial = pbxSerial;
        obj.baseUrl = `${serverURL}/` || `${DEFAULT_SERVER_URL}/`;
    } else {
        const roomData = APP.wildix.methods.getRoomData();
        const { roomToken, websocketUser, baseUrl, xBeesUserId = '' } = state['features/base/config'];

        obj.room = roomToken;
        obj.username = websocketUser;
        obj.xBeesUserId = xBeesUserId;
        obj.baseUrl = baseUrl;
        obj.pbxSerial = roomData.pbxSerial || null;
        obj.roomSubject = roomData.roomSubject || '';
    }

    return obj;
}
